export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname
export const toAbsoluteUrlImage = (pathname: string) => 'https://digitalfactory.co.in/lc_app_test/api/avatars/' + pathname
